import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dtm-container"
}
const _hoisted_2 = {
  key: 0,
  class: "header"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.currentmatter || _ctx.viewName)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.viewName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.viewName), 1))
          : _createCommentVNode("", true),
        (_ctx.currentmatter)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentmatter), {
              key: 1,
              ref: "child",
              onLoad: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('load')))
            }, null, 544))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}